import { Component, Input, OnInit } from '@angular/core';
import { PaymentDashboardTablesComponent } from '../payment-dashboard-tables.component';

@Component({
  selector: 'app-account-activity-table',
  templateUrl: './account-activity-table.component.html',
  styleUrls: ['./account-activity-table.component.scss'],
})
export class AccountActivityTableComponent
  extends PaymentDashboardTablesComponent
  implements OnInit
{
  @Input() isDsmDashboardOn: boolean;

  columnSizes: string[] = [
    '2',
    '1.2',
    '0',
    '1.2',
    '1.2',
    '1.2',
    '1.2',
    '1.2',
    '1.2',
    '1.2',
  ];

  ngOnInit() {
    this.setupColumns();
  }

  setupColumns() {
    if (this.isDsmDashboardOn) {
      this.columnSizes = [
        '1.8',
        '1',
        '0.9',
        '1.1',
        '1.1',
        '1.1',
        '1.2',
        '1.1',
        '1.1',
        '1.1',
      ];
    }
  }
}
